import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const HeroSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: "https://images.unsplash.com/photo-1761158495585-eac721decf1b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxyZXNpZGVudGlhbCUyMHJvb2Z0b3AlMjBzb2xhciUyMHBhbmVsc3xlbnwwfHx8fDE3NzYxNzEwNTF8MA&ixlib=rb-4.1.0&q=85",
      title: "Residential Rooftop Solar",
      subtitle: "Power your home with clean energy"
    },
    {
      image: "https://images.unsplash.com/photo-1684920334103-bfcac51b6a7c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxjb21tZXJjaWFsJTIwc29sYXIlMjBwbGFudHxlbnwwfHx8fDE3NzYxNzEwNTR8MA&ixlib=rb-4.1.0&q=85",
      title: "Commercial Solar Solutions",
      subtitle: "Maximize your business savings"
    },
    {
      image: "https://images.unsplash.com/photo-1726866492047-7f9516558c6e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwc29sYXIlMjBpbnN0YWxsYXRpb258ZW58MHx8fHwxNzc2MTcxMDYwfDA&ixlib=rb-4.1.0&q=85",
      title: "Industrial Solar Plants",
      subtitle: "Large-scale renewable energy solutions"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <div className="relative h-[600px] md:h-[700px] overflow-hidden">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent z-10" />
          <img
            src={slide.image}
            alt={slide.title}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 z-20 flex items-center">
            <div className="container mx-auto px-4 md:px-8">
              <div className="max-w-3xl text-white">
                <h2 className="text-3xl md:text-5xl font-bold mb-4 animate-fade-in">
                  {slide.title}
                </h2>
                <p className="text-lg md:text-2xl opacity-90">
                  {slide.subtitle}
                </p>
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* Navigation Buttons */}
      <button
        onClick={prevSlide}
        className="absolute left-4 top-1/2 -translate-y-1/2 z-30 backdrop-blur-sm text-white p-3 rounded-full transition-all duration-300"
        style={{ background: 'rgba(44,200,75,0.25)', border: '1px solid rgba(44,200,75,0.4)' }}
        onMouseEnter={e => e.currentTarget.style.background = 'rgba(44,200,75,0.45)'}
        onMouseLeave={e => e.currentTarget.style.background = 'rgba(44,200,75,0.25)'}
        aria-label="Previous slide"
      >
        <ChevronLeft className="w-6 h-6" />
      </button>
      <button
        onClick={nextSlide}
        className="absolute right-4 top-1/2 -translate-y-1/2 z-30 backdrop-blur-sm text-white p-3 rounded-full transition-all duration-300"
        style={{ background: 'rgba(0,188,212,0.25)', border: '1px solid rgba(0,188,212,0.4)' }}
        onMouseEnter={e => e.currentTarget.style.background = 'rgba(0,188,212,0.45)'}
        onMouseLeave={e => e.currentTarget.style.background = 'rgba(0,188,212,0.25)'}
        aria-label="Next slide"
      >
        <ChevronRight className="w-6 h-6" />
      </button>

      {/* Dots Indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-30 flex gap-3">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className="rounded-full transition-all duration-300"
            style={{
              width: index === currentSlide ? '2rem' : '0.75rem',
              height: '0.75rem',
              background: index === currentSlide
                ? 'linear-gradient(90deg, #2CC84B, #00BCD4)'
                : 'rgba(255,255,255,0.5)',
            }}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default HeroSlider;
